import { getEnErrorsTrnaslations } from "../constants/errors";

export default {
    appError: 'Ошибка - не удалось запустить приложение',
    appReload: 'Перезагрузить',
    nomatch: 'Page not found',
    title: 'Legal ground for personal data processing',
    titleKZ: 'Consent to Personal Data Processing',
    fields: {
        lastName: 'Surname',
        firstName: 'Name',
        middleName: 'Patronymic',
        birthdate: 'Date of birth',
        address: 'Residential address',
        email: 'Email address',
        phone: 'Contact phone number',
        cancelReason: 'Reason for refusal'
    },
    sureQuestion: 'Are you sure?',
    cancel: 'Cancel',
    radioYes: 'Yes',
    radioNo: 'No',
    approveDate: 'Approve date',
    submit: 'Submit',
    reject: 'Reject',
    error: 'Request fail to approve',
    cancelledError: 'Failed to send refusal',
    cancelledSuccess: 'Consent to the processing of personal data is rejected',
    success: 'Legal ground for personal data processing successfully approved!',
    languages: 'Language',
    countries: {
        label: 'Select the country in which you contacted ANCOR',
        ru: 'Russia',
        kz: 'Kazakhstan',
        by: 'Belarus',
        uz: 'Uzbekistan'
    },
    errors: {
        ...getEnErrorsTrnaslations()
    }
}
